import React, { Component } from 'react';
import PropTypes from 'prop-types';
import spacing from 'material-ui/styles/spacing';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import {darkWhite, lightWhite, grey900} from 'material-ui/styles/colors';
import '../App.css';
import AppBar from 'material-ui/AppBar';
import AppNavDrawer from '../components/AppNavDrawer';
import withWidth, {MEDIUM, LARGE} from 'material-ui/utils/withWidth';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import MenuItem from 'material-ui/MenuItem';
import AppSubMenu from '../components/AppSubMenu';
import {connect} from 'react-redux';
import {SelectCompanyEpic, SelectCompany} from '../actions/nav.actions';
import {withRouter} from 'react-router-dom';

class Master extends Component {

  static propTypes = {
    children: PropTypes.node,
    location: PropTypes.object,
    width: PropTypes.number.isRequired,
    logout: PropTypes.func
  };

  static contextTypes = {
    router: PropTypes.object.isRequired,
  };


  state = {
    navDrawerOpen: false,
  };

  getStyles() {
    const styles = {
      v1: {
        height: 40,
        backgroundColor: '#2196f3',
        display: 'flex',
        color: '#fff',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'fixed',
        top: 0,
        width: '100%',
        zIndex: this.state.muiTheme.zIndex.appBar + 1,
      },
      v1Spacer: {
        height: 40,
      },
      appBar: {
        position: 'fixed',
        // Needed to overlap the examples
        zIndex: this.state.muiTheme.zIndex.appBar + 1,
        top: 0,
      },
      root: {
        paddingTop: spacing.desktopKeylineIncrement,
        minHeight: 400,
      },
      content: {
        margin: 0,
      },
      contentWhenMedium: {
        margin: 0,
      },
      footer: {
        backgroundColor: grey900,
        textAlign: 'center',
      },
      a: {
        color: darkWhite,
      },
      p: {
        margin: '0 auto',
        padding: 0,
        color: lightWhite,
        maxWidth: 356,
      },
      browserstack: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        margin: '25px 15px 0',
        padding: 0,
        color: lightWhite,
        lineHeight: '25px',
        fontSize: 12,
      },
      browserstackLogo: {
        margin: '0 3px',
      },
      iconButton: {
        color: darkWhite,
      },
      navDrawer: {},
      rightElement: {
        position: 'relative',
        right: 0
      }
    };

    if (this.props.width === MEDIUM || this.props.width === LARGE) {
      styles.content = Object.assign(styles.content, styles.contentWhenMedium);
    }

    return styles;
  }

  constructor(props) {
    super(props);
    this.state = {value: 1};
  }

  handleTouchTapLeftIconButton = () => {
    this.setState({
      navDrawerOpen: !this.state.navDrawerOpen,
    });
  };

  handleChangeRequestNavDrawer = (open) => {
    this.setState({
      navDrawerOpen: open,
    });
  };

  handleChangeList = (event, value) => {
    if (value) {
      this.context.router.push(value);
      this.setState({
        navDrawerOpen: false,
      });
    }
  };

  componentWillMount() {
    this.setState({
      muiTheme: getMuiTheme(),
    });

    let location = this.props.router.location.pathname;
    let parts = location.split('/');
    let routeLocationId = '';
    if (parts[1] && parts[1]==='company' && parts[2]) {
      routeLocationId = parts[2];
    }

    if (routeLocationId && !this.props.selectedCompany) {
      this.props.setCompany(routeLocationId);
    }
  }

  handleChange = (event, index, value) => this.setState({value});

  render() {
    const {
      children,
    } = this.props;
    const styles = this.getStyles();
    let {
      navDrawerOpen,
    } = this.state;

    let docked = false;
    let showMenuIconButton = true;
    const title = "Ready Admin";
    if (this.props.width === LARGE && title !== '') {
      docked = true;
      navDrawerOpen = true;
      showMenuIconButton = false;

      styles.navDrawer = {
        zIndex: styles.appBar.zIndex - 1,
      };
      styles.root.paddingLeft = 256;
      styles.footer.paddingLeft = 256;
      styles.rightElement.right = 256;

      styles.headerTitleStyle = {
        flex: '1',
        flexDirection: 'row'
      }
    }

    return (
      <div style={styles.root}>
        <AppBar
          onLeftIconButtonTouchTap={this.handleTouchTapLeftIconButton}
          title={<AppSubMenu/>}
          zDepth={0}
          style={styles.appBar}
          showMenuIconButton={showMenuIconButton}
          iconElementRight={this.props.loggedIn? <LoggedInMenu style={styles.rightElement} logout={this.props.logout}/> : null }
        />
        <div style={styles.content}>
        {children}
        </div>
        <AppNavDrawer
          authRole={this.props.authData.companyRole}
          deselectCompany={this.props.deselectCompany}
          selectedCompany={this.props.selectedCompany}
          style={styles.navDrawer}
          docked={docked}
          onRequestChangeNavDrawer={this.handleChangeRequestNavDrawer}
          onChangeList={this.handleChangeList}
          open={navDrawerOpen}
          path={this.props.router.location.pathname}
        />
      </div>
    );
  }
}

const LoggedInMenu = (props) => (
  <IconMenu style={props.style}
    iconButtonElement={
      <IconButton><MoreVertIcon color={lightWhite} /></IconButton>
    }
    targetOrigin={{horizontal: 'right', vertical: 'top'}}
    anchorOrigin={{horizontal: 'right', vertical: 'top'}}
  >
    <MenuItem primaryText="Sign out" onClick={props.logout}/>
  </IconMenu>
);

const mapStateToProps = ({authEndpoint, nav}, router) => {
  debugger;

  return {
    authData: authEndpoint,
    selectedCompany: nav.selectedCompany,
    router
  };
};

const mapDispatchToProps = (dispatch) => ({
  deselectCompany: () => dispatch(SelectCompanyEpic(null)),
  selectCompany: (id) => dispatch(SelectCompanyEpic(id)),
  setCompany: (id) => dispatch(SelectCompany(id))
});

export default withRouter(withWidth()(connect(mapStateToProps,mapDispatchToProps)(Master)));



// WEBPACK FOOTER //
// ./src/containers/Master.js